<template>
  <label :for="id" :class="['input-radio-group', size]">
    <input
      :id="id" type="radio" :name="name" :value="value" :checked="checked" :class="['input-radio']"
      @change="onChange" />
    <span :class="['checkmark', description ? 'has-description' : 'no-description']"></span>
    <div class="input-radio-group__labeldesc">
      <div class="body-semibold-16">
        <slot></slot>
      </div>
      <span v-if="description" class="body-semibold-14">
        {{ description }}
      </span>
    </div>
  </label>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{
  id?: string
  label?: string
  description?: string
  name?: string
  value?: string | number
  checked?: boolean
  size?: string
}>(), {
  id: '',
  label: '',
  description: '',
  name: '',
  value: '',
  checked: false,
  size: 'medium',
})

const emit = defineEmits<{
  change: [value: string]
}>()

function onChange(e: Event) {
  const target = e.target as HTMLInputElement
  emit('change', target.value)
}
</script>

<style lang="scss" scoped>
.has-description {
    top: 25%;
}

.no-description {
    top: 0%;
}

.input-radio-group {
    display: flex;
    flex-direction: row;
    gap: 0.75rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    position: relative;
    padding-left: 1.95rem;


    label {
        margin: 0;
        padding: 0;
    }

    &__labeldesc {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
    }

    input[type="radio"] {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
        appearance: none;
    }

    .checkmark {
        position: absolute;
        left: 0;
        top: 25%;
        width: 1.25rem;
        height: 1.25rem;
        border: 1px solid var(--maincolor);
        border-radius: 50%;
        transition: background-color 0.3s, border-color 0.3s;
        cursor: pointer;
        outline: none;
        margin: 0;
        padding: 0;

        &:checked {
            background-color: var(--maincolor);
            border-color: var(--maincolor);
        }

        &:disabled {
            cursor: not-allowed;
            background-color: var(--maincolor);
            border-color: var(--maincolor);
        }

        &:disabled:checked {
            background-color: var(--maincolor);
            border-color: var(--maincolor);
        }
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    input:checked~.checkmark:after {
        display: block;
    }

    .checkmark:after {
        top: 20%;
        left: 20%;
        width: 0.625rem;
        height: 0.625rem;
        border-radius: 50%;
        background: var(--maincolor);
    }

    &.small {
        .input-radio-group {
            padding-left: 1.75rem;
        }

        input[type="radio"] {
            width: 1rem;
            height: 1rem;
        }
    }
}
</style>
